import Cookies from "js-cookie";

export enum COOKIE_NAME {
  CookieAnonymousId = "cookie-anonymous-id"
}

export const isMigrated = (): boolean => {
  const cookieAnonymousId = Cookies.get(COOKIE_NAME.CookieAnonymousId);
  return cookieAnonymousId === "true";
};
